/** Língua da vitrine para o locale de datas e dinheiro. */
export function localeOf(language: string): string {
  if (language.startsWith('en')) return 'en-US'
  if (language.startsWith('es')) return 'es-ES'
  return 'pt-BR'
}

export function money(cents: number, language: string): string {
  return new Intl.NumberFormat(localeOf(language), { style: 'currency', currency: 'BRL' }).format((cents ?? 0) / 100)
}

export function day(iso: string, language: string): string {
  return new Date(iso).toLocaleDateString(localeOf(language), { day: '2-digit', month: '2-digit', year: 'numeric' })
}

/** "10%" ou "R$ 5,00": percentual é o próprio número, valor fixo vem em centavos. */
export function rate(type: 'PERCENTAGE' | 'FIXED', value: number, language: string): string {
  if (type === 'PERCENTAGE') {
    return `${new Intl.NumberFormat(localeOf(language), { maximumFractionDigits: 2 }).format(value)}%`
  }
  return money(value, language)
}

/** Últimos N dias até hoje, em UTC, no formato que a API aceita. */
export function lastDays(days: number, now = new Date()): { from: string; to: string } {
  const to = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()))
  const from = new Date(to.getTime() - (days - 1) * 24 * 60 * 60 * 1000)
  return { from: from.toISOString().slice(0, 10), to: to.toISOString().slice(0, 10) }
}
